export default __webpack_public_path__ + "3d9faa20e435c2b1eb7c25ae48be5a45.png";